import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { renderRedirect } from "../../util";
import { verifyOTP } from "./api";
import $ from "jquery";
import { spinnerService } from "../../Components/spinner.service";
import OuterLogo from "../../Components/outer-logo";

class VerifyMobileOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: localStorage.getItem("mobile"),
      opt1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      formErrors: { otp1: "", otp2: "", otp3: "", otp4: "" },
      otpValid: false,
      errorMessage: null,
    };
  }

  async componentDidMount() {
    $("#otp-screen .form-control").keyup(function () {
      if (this.value.length === 0) {
        $(this).blur().parent().prev().children(".form-control").focus();
      } else if (this.value.length === this.maxLength) {
        $(this).blur().parent().next().children(".form-control").focus();
      }
    });
  }

  _renderRedirect = () => {
    // renderRedirect(this.props, "/language");
    //renderRedirect(this.props, "/welcome");
    renderRedirect(this.props, "/home");
  };

  _verifyOTP = async () => {
    spinnerService.show("mainSpinner", "Please wait...");

    let otpValue =
      this.state.otp1 + this.state.otp2 + this.state.otp3 + this.state.otp4;

    let otp = await verifyOTP(
      localStorage.getItem("mobile"),
      localStorage.getItem("session_id"),
      otpValue
    );
    // .catch(
    //   (errors) => {
    //     this.setState({
    //       // errorMessage: errors.message,
    //       errorMessage: "Error in verifying OTP",
    //     });
    //   }
    // );

    if (!otp?.data) {
      this.setState({
        errorMessage: otp?.errors[0]?.message || "Something Went Wrong",
      });
    }

    spinnerService.hide("mainSpinner");

    if (otp?.data?.verify_session_otp?.status) {
      localStorage.setItem("token", otp.data.verify_session_otp.token);
      this._renderRedirect();
    }
    // else if (otp && !otp.data?.verify_session_otp?.status) {
    //   this.setState({ errorMessage: otp.data.verify_session_otp.message });
    // }
  };

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let otpValid = this.state.otpValid;

    switch (fieldName) {
      case "otp1":
        otpValid = value.length === 1;
        fieldValidationErrors.otp1 = otpValid ? "" : " is invalid";
        break;
      case "otp2":
        otpValid = value.length === 1;
        fieldValidationErrors.otp2 = otpValid ? "" : " is invalid";
        break;
      case "otp3":
        otpValid = value.length === 1;
        fieldValidationErrors.otp3 = otpValid ? "" : " is invalid";
        break;
      case "otp4":
        otpValid = value.length === 1;
        fieldValidationErrors.otp4 = otpValid ? "" : " is invalid";
        break;
      default:
        break;
    }
    this.setState(
      { formErrors: fieldValidationErrors, otpValid: otpValid },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({ formValid: this.state.otpValid });
  }

  errorClass(error) {
    return error.length === 0 ? "" : "is-invalid";
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    if (this.state.errorMessage) {
      this.setState({ errorMessage: null });
    }
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }

  render() {
    const otpValue =
      this.state.otp1 + this.state.otp2 + this.state.otp3 + this.state.otp4;
    const ConfirmButton = ({ style }) => (
      <div className="form-button-group  transparent" style={{ ...style }}>
        <button
          type="button"
          // disabled={!this.state.formValid}
          disabled={otpValue.length !== 4}
          onClick={this._verifyOTP}
          className="btn btn-primary btn-block btn-lg"
        >
          CONFIRM
        </button>
      </div>
    );

    return (
      <div id="appCapsule">
        <OuterLogo />
        <div className="row">
          <div className="col col-md-4 d-none d-md-block" />
          <div className="col">
            <div className="section mt-2 text-center">
              <div className="container my-auto py-4 bg-white rounded">
                <div className="row mt-2">
                  <div className="col-11 col-lg-11 mx-auto">
                    <h2>Confirm OTP</h2>

                    <p className="text-muted text-2 text-center">
                      Please enter the OTP (one time password) to verify your
                      account. A Code has been sent to {" "}
                      <span className="text-dark text-4">
                        +91 {this.state.mobile}
                      </span>
                    </p>

                    {this.state.errorMessage ? (
                      <span
                        style={{ display: "block" }}
                        className="alert alert-warning alert-dismissible fade show"
                      >
                        {this.state.errorMessage}
                      </span>
                    ) : (
                      ""
                    )}

                    <form
                      id="otp-screen"
                      className="form-border verify-mobile-otp-form"
                      method="post"
                    >
                      <div className="form-row">
                        <div className="col form-group">
                          <input
                            inputMode="decimal"
                            pattern="[0-9]*"
                            className="form-control text-center text-6 px-0 py-2"
                            name="otp1"
                            onChange={(event) => this.handleUserInput(event)}
                            maxLength="1"
                            required
                            autoComplete="off"
                            autoFocus
                          />
                        </div>
                        <div className="col form-group">
                          <input
                            inputMode="decimal"
                            pattern="[0-9]*"
                            className="form-control text-center text-6 px-0 py-2"
                            name="otp2"
                            onChange={(event) => this.handleUserInput(event)}
                            maxLength="1"
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="col form-group">
                          <input
                            inputMode="decimal"
                            pattern="[0-9]*"
                            className="form-control text-center text-6 px-0 py-2"
                            name="otp3"
                            onChange={(event) => this.handleUserInput(event)}
                            maxLength="1"
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="col form-group">
                          <input
                            inputMode="decimal"
                            pattern="[0-9]*"
                            className="form-control text-center text-6 px-0 py-2"
                            name="otp4"
                            onChange={(event) => this.handleUserInput(event)}
                            maxLength="1"
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-md-4 d-none d-md-block" />
        </div>

        <div className="row">
          <div className="col col-md-4 d-none d-md-block" />
          <div className="col d-none d-md-block">
            <ConfirmButton style={{ position: "unset" }} />
          </div>
          <div className="col col-md-4 d-none d-md-block" />
        </div>
        <div className="row">
          <div className="col d-md-none">
            <ConfirmButton />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(VerifyMobileOTP);
